import {NgModule} from '@angular/core';
import {UserFullNamePipe} from './user/user-full-name.pipe';
import {ApplicationNamePipe} from './application/application-name.pipe';

@NgModule({
    declarations: [
        UserFullNamePipe,
        ApplicationNamePipe,
    ],
    imports: [],
    exports: [
        UserFullNamePipe,
        ApplicationNamePipe,
    ]
})
export class PipesModule {
}